import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { NumeroDocumentoInput } from 'sharedComponents/inputs/text'

import { KeyEventUtil } from 'utils'

const NumeroDocumentoBusquedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-tipoDocumentoBusqueda', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='N° DOC' htmlFor='input-infonota-numeroDocumentoBusqueda' md={12} />
      <Col md={12}>
        <Field name='numeroDocumentoBusqueda'>
          {({ field }) => (
            <NumeroDocumentoInput
              {...field}
              id='input-infonota-numeroDocumentoBusqueda'
              disabled={fIsSubmitting}
              isInvalid={iError && iTouched}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoBusquedaFormGroup)
